export default function ManchesterDistribution() {
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderRadius: 16, overflow: "hidden", border: "1px solid #E8E4D5", background: "#F4F1E7" }} className="dist-card-grid">
          {/* Content */}
          <div style={{ padding: "44px 44px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>Distribution</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(24px,3vw,34px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#112215", margin: "0 0 16px" }}>
              Listed on 16+ platforms, synced to one calendar
            </h2>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "#5C7268", lineHeight: 1.7, margin: 0 }}>
              Airbnb, Booking.com, Vrbo and thirteen more, all feeding a single calendar in real time. No double bookings, no manual updates.
            </p>
          </div>

          {/* Image — fills full height, no padding */}
          <div style={{ minHeight: 420, overflow: "hidden" }}>
            <img
              className="dist-img-desktop"
              src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/45b0b0d89_t.png"
              alt="Platform distribution across 16+ booking sites"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
            <img
              className="dist-img-mobile"
              src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/b0bbd88a3_t1.png"
              alt="Platform distribution across 16+ booking sites"
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "none" }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .dist-card-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 1024px) {
          .dist-img-desktop { display: none !important; }
          .dist-img-mobile { display: block !important; }
        }
      `}</style>
    </section>
  );
}